import { startFeatureAnimation } from '../editor'
import store from '../store'

const generateEvent = (group, useRandomTime = false) => {
  const now = new Date()
  const randomTimeAgo = Math.floor(Math.random() * 60 * 1000)
  const eventTime = new Date(now.getTime() - randomTimeAgo)

  const event = {
    type: 'group',
    pid: group.pid,
    lastMotionAt: useRandomTime ? eventTime.toISOString() : now.toISOString(),
  }
  return event
}

export const simulateRandomEvents = (groups, minDelay = 1000, maxDelay = 10000) => {
  let isRunning = true
  let timeoutId = null

  const triggerNextEvent = () => {
    if (!isRunning) return

    const randomDelay = Math.floor(Math.random() * (maxDelay - minDelay)) + minDelay
    const randomIndex = Math.floor(Math.random() * groups.length)
    const selectedGroup = groups[randomIndex]

    timeoutId = setTimeout(() => {
      const event = generateEvent(selectedGroup)
      startFeatureAnimation(event)
      triggerNextEvent()
    }, randomDelay)
  }

  triggerNextEvent()

  return () => {
    isRunning = false
    if (timeoutId) {
      clearTimeout(timeoutId)
    }
  }
}

const getRandomIds = (groups) => {
  const uniqueIds = [...new Set(groups.map((item) => item['spacePid']))]
  const shuffled = uniqueIds.sort(() => 0.5 - Math.random())
  return shuffled.slice(0, 2)
}

const sortGroupsByMotionType = (groups) => {
  const [randomId1, randomId2] = getRandomIds(groups)
  if (!randomId1 || !randomId2) {
    return { groupsWithMotion: groups, noMotionGroups: [] }
  }

  const result = groups.reduce(
    (acc, group) => {
      if (group['spacePid'] === randomId1) {
        acc.noMotionGroups.push(group)
      } else {
        acc.groupsWithMotion.push(group)
      }
      return acc
    },
    { groupsWithMotion: [], noMotionGroups: [] },
  )
  return result
}

export const fakeInitialEvents = (groups) => {
  const { groupsWithMotion, noMotionGroups } = sortGroupsByMotionType(groups)

  if (noMotionGroups.length > 0) {
    const noMotionSpace = store.activeFloorplan.spaces.find((space) => space.pid === noMotionGroups[0].spacePid)
    store.setNoMotionSpaces([noMotionSpace])
  }

  const events = groupsWithMotion.map((group) => generateEvent(group, true))
  events.forEach((event) => {
    startFeatureAnimation(event)
  })
}
